
export default function PortfolioSection() {
  const projects = [
    {
      title: 'Enterprise Cloud Migration',
      client: 'Fortune 500 Manufacturing Company',
      description: 'Complete migration of legacy systems to AWS cloud infrastructure, resulting in 40% cost reduction and improved scalability.',
      image: 'https://public.readdy.ai/ai/img_res/f74c68c66b63695259699f951be82000.jpg',
      tags: ['Cloud Migration', 'AWS', 'Infrastructure'],
      results: ['40% Cost Reduction', '99.9% Uptime', '3x Faster Deployment']
    },
    {
      title: 'Cybersecurity Overhaul',
      client: 'Regional Healthcare Network',
      description: 'Implementation of comprehensive cybersecurity framework including threat detection, compliance management, and staff training.',
      image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20operations%20center%20with%20multiple%20monitors%20displaying%20security%20dashboards%2C%20network%20monitoring%20systems%2C%20threat%20detection%20interfaces%2C%20professional%20security%20analysts%20working%2C%20high-tech%20security%20environment%2C%20blue%20and%20green%20color%20scheme&width=400&height=300&seq=portfolio-security&orientation=landscape',
      tags: ['Cybersecurity', 'HIPAA Compliance', 'Threat Detection'],
      results: ['Zero Security Breaches', '100% Compliance', '24/7 Monitoring']
    },
    {
      title: 'Custom ERP Development',
      client: 'Growing Retail Chain',
      description: 'Development of integrated ERP system connecting inventory, sales, and customer management across 25+ locations.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20ERP%20software%20interface%20on%20computer%20screens%20showing%20inventory%20management%2C%20sales%20analytics%2C%20and%20business%20dashboards%2C%20professional%20office%20environment%2C%20clean%20user%20interface%20design%2C%20business%20productivity%20tools&width=400&height=300&seq=portfolio-erp&orientation=landscape',
      tags: ['Custom Development', 'ERP', 'Integration'],
      results: ['25+ Locations', '30% Efficiency Gain', 'Real-time Analytics']
    },
    {
      title: 'Digital Transformation',
      client: 'Traditional Financial Services',
      description: 'Complete digital overhaul including mobile banking platform, automated processes, and advanced analytics implementation.',
      image: 'https://readdy.ai/api/search-image?query=Digital%20banking%20and%20financial%20technology%20interface%20with%20mobile%20apps%2C%20data%20analytics%20dashboards%2C%20modern%20fintech%20design%2C%20professional%20banking%20environment%2C%20digital%20transformation%20concept%2C%20blue%20and%20gold%20color%20scheme&width=400&height=300&seq=portfolio-fintech&orientation=landscape',
      tags: ['Digital Transformation', 'Mobile Banking', 'Analytics'],
      results: ['500K+ Users', '50% Process Automation', 'Enhanced Security']
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Success Stories
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how we've helped businesses transform their operations and achieve remarkable results through innovative IT solutions
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
              <img 
                src={project.image}
                alt={project.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-8">
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tags.map((tag, idx) => (
                    <span key={idx} className="px-3 py-1 bg-blue-100 text-blue-600 text-xs font-medium rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{project.title}</h3>
                <p className="text-sm text-blue-600 font-medium mb-3">{project.client}</p>
                <p className="text-gray-600 mb-6 leading-relaxed">{project.description}</p>
                
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                  {project.results.map((result, idx) => (
                    <div key={idx} className="text-center bg-gray-50 rounded-lg p-3">
                      <div className="text-sm font-semibold text-gray-900">{result}</div>
                    </div>
                  ))}
                </div>
                
                <a href="#contact" className="text-blue-600 font-medium hover:text-blue-700 transition-colors">
                  View Case Study <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
